module.exports = __webpack_public_path__ + "img/carpark_free_icon.48278a38.png";